<template >
  <div
    style="
      display: flex;
      justify-content: center;
      background-color: black;
      overflow: hidden;
    "
  >
    <div
      class="container"
      style="
        text-align: center;
        padding-top: 100px;
        height: 100vh;
        width: 100%;
        overflow: hidden;
        max-width: 600px;
      "
    >
      <img
        :src="require('/src/assets/findpop_images/findpop_ico.png')"
        alt="Findpop"
        width="60%"
        height="auto"
      />
      <form id="loginForm">
        <div style="margin-bottom: 50px; color: #838383; font-size: 13px">
          Please login to your FINDPOP account.
        </div>

        <div>
          <input
            type="text"
            required="true"
            placeholder="Username"
            @click="show_msg = ''"
            autocomplete="off"
            v-model="username"
            @input="onInput"
          />
        </div>
        <div
          style="
            display: flex;
            align-items: baseline;
            justify-content: center;
            position: relative;
          "
        >
          <input
            :type="check_state"
            required="true"
            placeholder="Password"
            @click="show_msg = ''"
            autocomplete="off"
            v-model="password"
          />
          <i
            style="position: absolute; right: 16%; top: 20%"
            class="fa"
            :class="check_state == 'password' ? 'fa-eye' : 'fa-eye-slash'"
            id="togglePasswordState"
            @click="togglePasswordState()"
          ></i>
        </div>
        <div id="message" v-if="show_msg" style="color: #bc1515">
          {{ show_msg }}
        </div>
        <input
          class="submit"
          @click.prevent="submit()"
          type="submit"
          value="Log in"
        />
      </form>

      <div id="tips" style="color: #afafafd4; font-size: smaller"></div>

      <div style="color:#8e8c88">{{  client_msg }}</div>
    </div>
    
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { ref } from "vue";


const onInput = (event) => {
  
  username.value = event.target.value.replace(/\s+/g, '')

};

onMounted(() => {

let client_id = getQueryParam("client_id");
if(client_id?.includes('google')){
  client_msg.value='By signing in, you are authorizing Google to control yourdevices'
}
else if(client_id?.includes('alexa')){
  client_msg.value='By signing in, you are authorizing Alexa to control yourdevices'
}
});

const check_state = ref("password");
const username = ref("");
const password = ref("");
const show_msg = ref("");
const client_msg = ref("");
function getQueryParam(key) {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}

function togglePasswordState() {
  check_state.value == "password"
    ? (check_state.value = "text")
    : (check_state.value = "password");
}

function submit() {
  var client_id = getQueryParam("client_id");
  var redirect_uri = getQueryParam("redirect_uri");
  var state = getQueryParam("state") || "";
  // 收集表单数据

  const formData = {
    username: username.value,
    password: password.value,
    client_id: client_id,
    redirect_uri: redirect_uri,
  };
  //发送登录请求
  fetch("/third-control/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // 获取返回数据后处理逻辑，如重定向到其他页面等
      if (data.code == 0) {
        window.location.href = `${redirect_uri}?state=${state}&code=${data.data.authCode}`;
      } else {
        if (data.code == 20002) {
          show_msg.value = "Incorrect password";
        } else if (data.code == 20000) {
          show_msg.value = "User does not exist";
        } else {
          show_msg.value = "unknown error:" + data.code;
        }
      }
    })
    .catch((error) => {
      // 处理登录失败的逻辑，如显示错误信息等
      console.error("Error logging in:", error);
      show_msg.value = "" + error;
    });
}
</script>




<style scoped>
form input {
  border: none;
  outline: none;
  font-size: 16px;
  text-align: center;
  width: 70%;
  height: 40px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.submit {
  border-radius: 10px;
  border: 1px solid rgba(25, 124, 119, 0.568);
  border-radius: 5px;
  /* background:linear-gradient(45deg, #76dde0, #31f4f6); */
  background-color: #0090ff;
  width: 70%;
  height: 50px;
  cursor: pointer;
  margin-top: 10px;
  transition: all 0.4s;
  font-family: math;
  font-weight: 600;
}

.submit:hover {
  background-color: #d451c5;
}

#togglePassword {
  cursor: pointer;
  position: absolute;
  right: 16%;
  top: 20%;
}
#message {
  color: red;
  font-size: 14px;
  transition: all 0.4s;
}
</style>